import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../../hooks';
import history from '../../../browserHistory';
import { Button } from 'semantic-ui-react';
import { Logo, Icon } from '../../../components/Dashboard';
import logo from '../../../assets/images/logo.png';
// import { ConfirmModal, Logo } from 'components/project/ClerkScreen';
import { Container, Title, LeftSide, RightSide, Middle } from './Styles';
import { ItemText } from '../SideNavContainer/Item/Styles';

const TopBarContainer = ({
  auctionAndLaneName,
  title,
  connected,
  laneName,
  showLogout,
  showLogo,
  screenName,
  memberName,
}) => {
  const {
    APIWebSocketStore: { disconnect },
    AuthStore: { logOut },
    UIStore: { apiWebSocketStore, handleLogout, headerText },
  } = useStores();

  const handleSignOut = async () => {
    disconnect();
    logOut();
  };

  return (
    <Container>
      <LeftSide>
        <Logo
          url={`${process.env.PUBLIC_URL}${logo}`}
          alt="National Powersport Auctions"
          width="150px"
        />
      </LeftSide>
      <Middle>
        {/* <Title>{auctionAndLaneName}</Title> */}
        <Title data-testid="header-text">
          {headerText || auctionAndLaneName}
        </Title>
        {/* <Title>{title}</Title> */}
      </Middle>
      <RightSide>
        <Icon size="2" icon="user-circle" />
        <span data-testid="member-name">{memberName}</span>
        <Button
          data-testid="logout-button"
          color="red"
          size="small"
          content="Logout"
          icon="sign-out"
          style={{ margin: '0px 25px' }}
          onClick={handleSignOut}
        />
      </RightSide>
    </Container>
  );
};

TopBarContainer.defaultProps = {
  title: '',
  connected: false,
};

TopBarContainer.propTypes = {
  title: PropTypes.string.isRequired,
  connected: PropTypes.bool.isRequired,
};

export default observer(TopBarContainer);
